document.addEventListener("DOMContentLoaded", function () {
  //SEARCH TOGGLE
  var slideOpen = true;
  document.querySelector("#btn_search").addEventListener("click", function () {
    var searchForm = document.querySelector(".search_form form");
    if (slideOpen) {
      slideOpen = false;
      searchForm.style.height = "35px";
      // searchForm.style.visibility = 'visible';
    } else {
      slideOpen = true;
      searchForm.style.height = "0px";
    }
  });
  //MENU TOGGLE
  if (window.screen.width < 800) {
    // ----- MENU -----
    var menu = document.querySelector(".main_header .menu_icon");
    menu.addEventListener("click", toggleMenu);
    function toggleMenu() {
      var menuForm = document.querySelector("#nav_toggle");
      if (menuForm.style.display === "block") {
        menuForm.style.display = "none";
      } else {
        menuForm.style.display = "block";
      }
    }
    // ----- END OF MENU -----
    // ----- SUB_MENU -----
    var arrowIcon = document.querySelectorAll(".submenu_mobile_icn");
    arrowIcon.forEach(function (i) {
      i.addEventListener("click", toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.parentNode.children[2].style.display === "block") {
          this.parentNode.children[2].style.display = "none";
        } else {
          this.parentNode.children[2].style.display = "block";
        }
      }
    });
    // ----- END OF SUB_MENU -----
  }

  //---------TOP NEWS SLIDER---------
  if (document.getElementById("top_slider")) {
    new Splide("#top_slider", {
      type: "loop",
      perPage: 1,
      pagination: false,
      gap: "1em",
      focus: "center",
      autoplay: true,
      interval: 3000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      arrows: true,
      // padding: '10%',
    }).mount();
  }

  //MIDDLE Slider
  if (document.getElementById("mid_slider")) {
    new Splide("#mid_slider", {
      type: "loop",
      perPage: 1,
      pagination: false,
      gap: "1em",
      focus: "center",
      autoplay: true,
      interval: 3000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      arrows: true,
      // padding: '10%',
    }).mount();
  }

  // LANDING A Slider
  if (document.getElementById("landing_slider")) {
    new Splide("#landing_slider", {
      type: "loop",
      perPage: 1,
      pagination: false,
      gap: "1em",
      focus: "center",
      autoplay: true,
      interval: 3000,
      whell: true,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      arrows: true,
      // padding: '10%',
    }).mount();
  }

  // ---------- CLOSING BREAKING NEWS ----------
  const emergencyClose = document.getElementById("emergency_close");
  if (emergencyClose) {
    emergencyClose.addEventListener("click", function () {
      const breakingNews = document.querySelector(".breaking_news_cnt");
      if (breakingNews) {
        let opacity = 1;
        const fade = setInterval(function () {
          opacity -= 0.05;
          breakingNews.style.opacity = opacity;
          if (opacity <= 0) {
            clearInterval(fade);
            breakingNews.style.display = "none";
          }
        }, 20);
      }
    });
  }
  // ---------- END OF CLOSING BREAKING NEWS ----------

  // ---------- RELATED NEWS ----------
  const echoDetail = document.getElementById("echo_detail");
  const inlineRelatedNews = document.getElementById("inline_relatednews");

  if (echoDetail && inlineRelatedNews) {
    const allParas = Array.from(echoDetail.querySelectorAll("p")).filter(
      function (p) {
        return !p.closest("table");
      },
    );
    const parLength = allParas.length;
    const p1st = allParas[0];

    if (parLength > 1 && p1st) {
      p1st.insertAdjacentElement("afterend", inlineRelatedNews);
    } else {
      echoDetail.appendChild(inlineRelatedNews);
    }
  }
  // ---------- END OF RELATED NEWS ----------

  // ---------- FIRST INLINE ADVERTISEMENT ----------
  const inlineFirstAdv = document.getElementById("inline_first_adv");

  if (echoDetail && inlineFirstAdv) {
    const allParasForAdv = echoDetail.querySelectorAll("p");
    const parLengthAdv = allParasForAdv.length;
    const p2nd = allParasForAdv[1];

    if (parLengthAdv >= 2 && p2nd) {
      p2nd.insertAdjacentElement("afterend", inlineFirstAdv);
    } else {
      inlineFirstAdv.remove();
    }

    // ---------- SECOND INLINE ADVERTISEMENT ----------
    const inlineSecondAdv = document.getElementById("inline_second_adv");

    if (inlineSecondAdv) {
      const p6th = allParasForAdv[5];
      if (parLengthAdv >= 6 && p6th) {
        p6th.insertAdjacentElement("afterend", inlineSecondAdv);
      } else {
        inlineSecondAdv.style.display = "none";
      }
    }
    // ---------- END OF SECOND INLINE ADVERTISEMENT ----------
  }
  // ---------- END OF FIRST INLINE ADVERTISEMENT ----------

  // ---------- TAB ----------
  const tabHeaders = document.querySelectorAll(".first_tab #tab_header li");
  const tabContents = document.querySelectorAll("#tab_content > div");

  tabHeaders.forEach(function (tab, index) {
    tab.addEventListener("click", function () {
      if (!this.classList.contains("active")) {
        document
          .querySelector(".first_tab #tab_header li.active")
          ?.classList.remove("active");
        this.classList.add("active");

        document
          .querySelector("#tab_content > div.active")
          ?.classList.remove("active");
        if (tabContents[index]) tabContents[index].classList.add("active");
      }
    });
  });
  // ---------- END OF TAB ----------

  // ---------- ARCHIVE TOGGLE ----------
  document.querySelectorAll(".flip").forEach(function (flip) {
    flip.addEventListener("click", function () {
      const next = this.nextElementSibling;
      if (!next) return;

      if (next.style.display === "none" || next.style.display === "") {
        next.style.display = "block";
        let height = next.scrollHeight;
        next.style.overflow = "hidden";
        next.style.maxHeight = "0";
        next.style.transition = "max-height 0.6s ease";
        requestAnimationFrame(() => {
          next.style.maxHeight = height + "px";
        });
      } else {
        next.style.maxHeight = "0";
        next.style.transition = "max-height 0.6s ease";
        setTimeout(() => {
          next.style.display = "none";
          next.style.maxHeight = "";
        }, 600);
      }
    });
  });
  // ---------- END OF ARCHIVE TOGGLE ----------

  // Hiding title and svg on video play & play by click on svg
  const video = document.getElementById('video_mainpage');
  const title = document.getElementById('video_title');
  const svg = document.getElementById('video_svg');

  function playVideoAndHideElements() {
    video.play();              
    video.setAttribute('controls', 'controls'); 
    title.style.display = 'none';
    svg.style.display = 'none';
  }

  video.addEventListener('click', playVideoAndHideElements);
  svg.addEventListener('click', playVideoAndHideElements);
});



// ---------- ALBUM COPY SHORT LINK ----------
function albumCopyShortLink() {
  const copyText = document.getElementById("album_short_link_input");
  if (!copyText) return;

  copyText.select();
  document.execCommand("copy");

  const tooltip = document.querySelector(".album_tooltip_text");
  if (tooltip) {
    tooltip.classList.toggle("album_tooltip_text_show");
    setTimeout(function () {
      tooltip.classList.toggle("album_tooltip_text_show");
    }, 2000);
  }
}
// ---------- END OF ALBUM COPY SHORT LINK ----------
